"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setKanbanStyle = void 0;
const i18n_1 = require("../../exports/i18n");
const model_1 = require("../../model");
const selectors_1 = require("../../exports/store/selectors");
const types_1 = require("../../types");
const command_manager_1 = require("../../command_manager");
const selectors_2 = require("../../exports/store/selectors");
const __1 = require("..");
const add_records_1 = require("./add_records");
exports.setKanbanStyle = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { viewId, addRecord, styleValue } = options;
        const datasheetId = (0, selectors_1.getActiveDatasheetId)(state);
        const datasheet = (0, selectors_2.getDatasheet)(state, datasheetId);
        if (!state || !datasheet) {
            return null;
        }
        // Determine whether the currently operating view is the active view
        if (datasheet.activeView !== viewId) {
            throw new Error((0, i18n_1.t)(i18n_1.Strings.error_modify_column_failed_wrong_target_view));
        }
        const actions = [];
        const setKanbanStyleAction = model_1.KanbanView.setViewStyle2Action(datasheet.snapshot, options);
        setKanbanStyleAction && actions.push(setKanbanStyleAction);
        if (addRecord) {
            const rowCount = (0, selectors_1.getActualRowCount)(state);
            const unitId = state.user.info.unitId;
            const addRecordActions = add_records_1.addRecords.execute(context, {
                cmd: __1.CollaCommandName.AddRecords,
                viewId,
                index: rowCount,
                count: 1,
                cellValues: [{ [styleValue]: [unitId] }],
            });
            if (addRecordActions) {
                if (addRecordActions.result === command_manager_1.ExecuteResult.Fail) {
                    return addRecordActions;
                }
                actions.push(...addRecordActions.actions);
            }
        }
        if (actions.length === 0) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
        };
    },
};
//# sourceMappingURL=set_kanban_style.js.map